<template>
	<div class="home-page">
		<nio-header-nav
			ref="headerNav"
			position="fixed"
			:scrollListener="true"
			@back="handleClose"
			:height.sync="navHeight"
			:blackIcon="pullRefreshStatus !== 'normal'"
			v-if="$isInWebview"
		>
			<div class="right-btn-list">
				<nio-icon
					@click="onRightButtonClick('icon_collect_list_m')"
					:size="28"
					name="icon_collect_list_m"
				/>

				<nio-icon
					@click="onRightButtonClick('icon_service_medium_m')"
					:size="28"
					name="icon_service_medium_m"
				/>
			</div>
		</nio-header-nav>

		<pull-refresh
			v-model="pullingRefresh"
			:status.sync="pullRefreshStatus"
			@refresh="handleRefresh"
			:pull-height="navHeight"
			:pull-distance="navHeight"
			:head-height="navHeight"
			class="pull-refresh"
		>
			<div>
				<div v-if="!banners.length" style="width: 100vw; height: 100vw;" />
				<nio-banner
					v-else
					:list="banners.map(item => ({ url: cdn(item.img, '/thumbnail/!750x750r', true) }))"
					:useWideScreen="isWideScreen"
					bannerItemWidth="375px"
					bannerItemHeight="375px"
					@banner-click="handleBannerClick"
					@change="handleBannerChange"
				></nio-banner>
			</div>
			<div class="main-content">
				<div class="main-button-array">
					<div v-for="entry in entries" @click="jump(entry.link, entry.name)" class="main-button">
						<img :src="entry.img" />
						<span>{{ entry.name }}</span>
					</div>
				</div>
				<!-- 为你推荐 -->
				<car-filter
					ref="carFilter"
					:scrollTop="scrollTopNum"
					:config.sync="filterConfig"
					:listTheme.sync="listTheme"
					:selectedRecommends.sync="selectedRecommends"
					:nav-height="navHeight"
				/>

				<div v-if="recommendMode">
					<div v-if="recommendMode" class="no-cars-warning">
						<!-- <p class="no-cars-tips">暂无所选车型，已为你推荐其它车辆</p> -->
						<p class="no-cars-tips">当前城市无相关车源，为你推荐以下车源：</p>
					</div>
				</div>

				<!-- 商品列表 -->
				<ul class="car-list-wrapper">
					<template v-if="cars.length || loading">
						<li
							v-for="(item, index) in cars"
							:key="item.commodity_code + index"
							@click="enterDetail(item)"
							v-sd-exp:MallMktExpo="getCarItemExposureInfo(item, index)"
							v-sd-clk:MallMktClick="getCarItemTouchInfo(item, index)"
							:class="listTheme"
						>
							<car-item
								:car="item"
								:theme="listTheme"
								:show-collect="true"
								@collect="collected => onCollectChange(item, index, collected)"
							/>
						</li>
						<div class="load-more-area" :style="{ paddingBottom: safeInsetBottom + 'px' }">
							<div class="loading-more-inner">
								<div v-if="pagination.error" class="status-fail">
									无法加载,
									<span class="retry-btn" @click="loadMore">重试</span>
								</div>

								<div v-else-if="pagination.hasMore" class="status-loading">
									<van-loading type="spinner" :size="20" :style="{ marginRight: '8px' }" />
									加载中
								</div>

								<div v-else class="status-end">
									已经到底啦
								</div>
							</div>
						</div>
					</template>
				</ul>
			</div>
		</pull-refresh>

		<nio-sheet v-model="showContact">
			<contact-popup @close="showContact = false" @select="handleSelectItem" />
		</nio-sheet>

		<portal-target name="sort-way"></portal-target>

		<portal-target name="filter-panel"></portal-target>
	</div>
</template>

<script>
import { NioIcon } from '@nio-fe/nio-app-ui'
import { commonConfigModel, getMyVehicles, queryVehicles } from '@/model'
import configModel from '@/model/ConfigModel'
import CarFilter from '@/views1/IndexPage/CarFilterBar'
import util from '@/util/util'
import SubscriptionIcon from '@/assets/svg/icon_Subscription.svg'
import CarItem from '@/components/CarItem'
import noCarImg from '@/assets/images/no-car.png'
import IconCollect from '@/assets/svg/carhome/icon_collect.svg'
import link from '@/util/link'
import hybrid from '@/util/nativeHybrid'
import {
	allCarDisabledStatus,
	allCarTypes,
	allSeller,
	allSortWays,
	getCarFullTitle,
	getEmptyFilter,
	getVehicleQueryParams
} from '@/views1/IndexPage/filterOptions'
import ContactPopup from '@/components/ContactPopup'
import sensors from '@/util/dataTrack'
import { mapMutations, mapState } from 'vuex'
import PullRefresh from '@/components/pull-refresh'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import { cdn } from '@/util/imgCdn'
import { supreme } from '@/supreme-core'

NioIcon.add('carhome-collect', IconCollect)

export default {
	name: 'Index',
	components: { ContactPopup, CarItem, CarFilter, PullRefresh },

	data() {
		const modelCode = supreme.getQueryString('model_code')
		const queryModelCodes = Array.isArray(modelCode) ? modelCode[0] : modelCode
		const initialCarTypes = (typeof queryModelCodes === 'string' ? queryModelCodes : '')
			.split(',')
			.map(modelCode => {
				const tModelCode = modelCode.trim().toUpperCase()
				return tModelCode === 'TT5' ? 'ET5T' : tModelCode
			})
			.filter(carType => allCarTypes.includes(carType))

		return {
			SubscriptionIcon,
			noCarImg,
			IconCollect,
			homeData: [],
			loading: false,
			requestId: null,
			showContact: false,

			scrollTopNum: 0,

			filterConfig: {
				...getEmptyFilter(),
				sellers: [], // 进入时默认选中官方
				carTypes: initialCarTypes
			},
			listTheme: 'normal', //  normal: 普通模式 , large: 大图模式
			selectedRecommends: [],
			navHeight: 0,

			pagination: {
				page: 0,
				total: 0,
				hasMore: true,
				error: false
			},
			cars: [],

			token: util.getToken(),

			pullingRefresh: false,
			pullRefreshStatus: 'normal',

			recommendMode: false,

			safeInsetBottom: getSafeInsetBottom(),
			banners: [],
			entries: []
		}
	},
	computed: {
		...mapState('homeState', {
			collectedRecord: state => state.collectedRecord,
			cancelCollectRecord: state => state.cancelCollectRecord
		}),
		rankingType() {
			if (allSortWays.some(one => one.value === this.filterConfig.sort)) {
				return allSortWays.find(one => one.value === this.filterConfig.sort).label
			}
			return '综合排序'
		},
		tabName() {
			if (!this.selectedRecommends.length) {
				return '官方'
			}
			return this.selectedRecommends.join(',')
		},
		filterList() {
			const list = []

			if (this.filterConfig.carTypes.length) {
				list.push(...this.filterConfig.carTypes)
			}

			if (this.filterConfig.sellers.length) {
				list.push(
					...this.filterConfig.sellers.map(sellerType => {
						return allSeller.find(({ value }) => value === sellerType)
							? allSeller.find(({ value }) => value === sellerType).label
							: ''
					})
				)
			}

			if (this.filterConfig.baasTypes.length === 1 && this.filterConfig.baasTypes[0] === 2) {
				list.push('baas')
			}

			if (this.filterConfig.colors.length) {
				list.push(...this.filterConfig.colors)
			}

			if (this.filterConfig.priceRanges.length) {
				list.push(
					...this.filterConfig.priceRanges.map(range => {
						return `[${range[0]}, ${range[1]}]`
					})
				)
			}

			if (this.filterConfig.ages.length) {
				list.push(
					...this.filterConfig.ages.map(range => {
						return `[${range[0]}, ${range[1]}]`
					})
				)
			}

			if (this.filterConfig.mileages.length) {
				list.push(
					...this.filterConfig.mileages.map(range => {
						return `[${range[0]}, ${range[1]}]`
					})
				)
			}

			return list
		},

		queryVehicleParams() {
			return getVehicleQueryParams(this.filterConfig)
		},
		pageSource() {
			return this.$route.query.page_source
		},
		isWideScreen() {
			return hybrid.isWideScreen()
		}
	},
	created() {
		window.document.documentElement.style.setProperty(
			'--full-viewport-height',
			`${window.innerHeight}px`
		)

		this.getCartShopping().then(() => {
			sensors.track('KeyPageView', {
				page: '二手车商城',
				requirement_id: 2015,
				track_sign: 'aMall.b30.pageview.KeyPageView',
				page_duration: null,
				page_source: this.pageSource,
				screen_parameter: [
					// 收集屏幕信息
					Math.floor((100 * window.innerHeight) / window.innerWidth) / 100 + '',
					window.innerWidth + '',
					window.innerHeight + '',
					window.devicePixelRatio + '',
					window.Proxy ? '1' : '0'
				]
			})
		})

		this.getBannersConfig()
		this.cleanCollectState()

		hybrid.disableWebviewPull()
	},
	mounted() {
		const onScroll = () => {
			this.scrollTopNum = util.getWindowScrollTop()
		}

		window.addEventListener('scroll', onScroll)

		this.listenLoadMore(() => this.loadMore())

		// window.addEventListener("visi")
		// 原先禁止下拉刷新的
		// hybrid.disableWebviewPull();
		console.log('%c[AOLIN]', 'color:#3b92de', util.getToken())
		console.log('%c[AOLIN]', 'color:#3b92de', 'isLg', hybrid.isCNLg())
		document.addEventListener('visibilitychange', () => {
			// this.handleRefresh();
			this.$forceUpdate()
		})

		configModel.getCommonConfig().then(data => {
			this.entries = data.entries || []
		})
	},
	methods: {
		...mapMutations('homeState', ['syncCollectState', 'cleanCollectState']),
		cdn,
		getCarFullTitle,
		getCartShopping(recommend) {
			return new Promise(async resolve => {
				try {
					const requestId = Date.now()
					this.loading = true
					this.requestId = requestId
					const queryParams = recommend ? getEmptyFilter() : this.queryVehicleParams

					const { data } = await queryVehicles.post({
						...queryParams,
						offset: this.pagination.page * 20,
						limit: 20
					})
					if (this.requestId !== requestId) {
						throw new Error('debounce')
					}

					if (data.result_code !== 'success') {
						throw new Error()
					}

					if (this.pagination.page === 0) {
						this.cars = data.data.list
					} else {
						this.cars = this.cars.concat(data.data.list)
					}

					this.pagination.total = data.data.total
					this.pagination.page += 1
					this.pagination.hasMore = this.cars.length < this.pagination.total

					return resolve()
				} catch (e) {
					if (e.message === 'debounce') {
						return
					}
					this.pagination.error = true
				} finally {
					this.loading = false
				}
			})
		},

		async getBannersConfig() {
			const res = await commonConfigModel.get({
				keys: 'banner'
			})
			this.banners = res.data.data.banner
		},
		isSelled(car) {
			return car.state_text && car.state_text.indexOf('已售') >= 0
		},
		cleanFilter() {
			this.filterConfig = getEmptyFilter()
		},
		onRightButtonClick(iconName) {
			if (iconName === 'icon_collect_list_m') {
				sensors.track('SecondCarClick', {
					button_name: '收藏夹',
					page: '二手车商城',
					track_sign: 'aMall.b30.d539.click.SecondCarClick'
				})

				if (!util.isToken()) {
					hybrid.openLoginPage(() => {
						link.goToRoute('/collection')
					})
				} else {
					link.goToRoute('/collection')
				}
			} else {
				sensors.track('SecondCarClick', {
					button_name: '联系客服',
					page: '二手车商城',
					requirement_id: 2015,
					track_sign: 'aMall.b30.d4306.click.SecondCarClick'
				})
				this.showContact = true
			}
		},
		handleSelectItem(name) {
			sensors.track('SecondCarClick', {
				button_name: name,
				page: '二手车商城',
				requirement_id: 2015,
				track_sign: 'aMall.b30.d4306.click.SecondCarClick'
			})
		},
		handleClose() {
			sensors.track('SecondCarClick', {
				track_sign: 'aMall.b30.d32.click.SecondCarClick',
				page: '二手车商城',
				button_name: '返回'
			})

			hybrid.closeSyn()
		},
		async enterSeller() {
			await util.checkLogin()
			getMyVehicles
				.get({})
				.then(res => {
					const { data } = res.data || {}

					if (data.vehicles && data.vehicles.length) {
						link.goToSeller()
					} else {
						link.goToRoute('/no-seller')
					}
				})
				.catch(e => {
					link.goToSeller()
				})
		},
		jump(link, buttonName) {
			sensors.track('SecondCarClick', {
				button_name: buttonName,
				page: '二手车商城',
				requirement_id: 2015,
				track_sign: 'aMall.b30.d4306.click.SecondCarClick'
			})
			if (link === 'seller') {
				return this.enterSeller()
			}
			let href = util.getBaseEnvInfo()[link]
			if (link.indexOf('http') > -1) {
				href = link
			}

			hybrid.openURL(href)
		},
		listenLoadMore(fn) {
			let timer = null
			const onScroll = () => {
				if (timer !== null) {
					clearTimeout(timer)
				}
				timer = setTimeout(() => {
					if (window.scrollY + window.innerHeight > document.body.scrollHeight - 10) {
						fn()
					}
				}, 50)
			}

			window.addEventListener('scroll', onScroll)
		},
		loadMore() {
			if (!this.pagination.hasMore || this.loading) {
				return
			}

			this.pagination.error = false

			const inRecommend = this.recommendMode
			this.getCartShopping(inRecommend)
		},

		handleRefresh() {
			this.pagination.page = 0
			this.pagination.hasMore = true
			this.pagination.error = false

			this.getCartShopping()
				.then(() => {
					if (!this.cars.length) {
						this.recommendMode = true
						this.searchRecommend()
					} else {
						this.recommendMode = false
						if (window.scrollY > this.$refs.carFilter.$el.offsetTop) {
							window.scrollTo({
								top: this.$refs.carFilter.$el.offsetTop
							})
						}
					}
				})
				.finally(() => {
					setTimeout(() => {
						this.pullingRefresh = false
					}, 500)
				})
		},
		enterDetail(carItem) {
			if (allCarDisabledStatus.some(one => one.value === carItem.status)) {
				const statusName = allCarDisabledStatus.find(one => one.value === carItem.status).label
				hybrid.showToast(`该商品${statusName}，，无法进入详情`)
				return
			}
			const { commodity_code, is_favorite } = carItem
			link.goToRoute('/detail', {
				sku_code: commodity_code,
				is_favorite
			})
		},

		onCollectChange(item, index, collected) {
			sensors.track('MallMktClick', {
				track_sign: 'aMall.b22.d23.click.MallMktClick',
				page_source: this.pageSource,
				button_name: '收藏',
				...this.getCarItemTrackingInfo(item, index)
			})
		},

		handleBannerClick({ index }) {
			sensors.track('SecondCarClick', {
				track_sign: 'aMall.b30.d4306.click.SecondCarClick',
				requirement_id: 2015,
				page: '二手车商城',
				page_source: this.pageSource,
				button_name: 'banner',
				resource_name: this.banners[index].name,
				position_in_rank: index + 1
			})
			hybrid.openURL(this.banners[index].link.link)
		},

		handleBannerChange({ index }) {
			sensors.track('MallMktExpo', {
				page: '二手车商城',
				mkt_type: 'banner',
				mkt_url: this.banners[index].link.link,
				mkt_in_type: ''
			})
		},

		getLabelNamesStr(item) {
			const labelNames = []
			if (item.tags && item.tags.length) {
				item.tags.forEach(tag => {
					labelNames.push(tag.tag_name)
				})
			}

			return labelNames.join(',')
		},
		getCarItemExposureInfo(item, index) {
			return {
				page: '二手车商城',
				mkt_in_number: this.cars.length,
				mkt_in_mode: this.listTheme === 'normal' ? '小卡模式' : '大卡模式',
				tab_name: this.tabName,
				label_name: this.getLabelNamesStr(item),
				track_sign: 'aMall.b22.c2237.d2238.exposure.MallMktExpo'
			}
		},
		getCarItemTouchInfo(item, index) {
			return {
				page: '二手车商城',
				page_source: this.pageSource,
				mkt_in_id: item.commodity_code,
				mkt_in_rank: index + 1,
				mkt_in_mode: this.listTheme === 'normal' ? '小卡模式' : '大卡模式',
				tab_name: this.tabName,
				label_name: this.getLabelNamesStr(item),
				track_sign: 'aMall.b22.c2237.d2239.click.MallMktClick'
			}
		},
		getCarItemTrackingInfo(item, index) {
			return {
				page: '二手车商城',
				mkt_in_id: item.commodity_code,
				mkt_in_title: this.getCarFullTitle(item),
				mkt_in_rank: index + 1,
				mkt_in_number: this.cars.length,
				ranking_type: this.rankingType,
				filter_list: this.filterList,
				tab_name: this.tabName,
				mkt_in_type: '商品'
			}
		},
		searchRecommend() {
			this.pagination.page = 0
			this.pagination.hasMore = true
			this.getCartShopping(true)
		}
	},
	watch: {
		filterConfig: {
			deep: true,
			handler() {
				this.recommendMode = false
				this.handleRefresh()
			}
		}
	}
}
</script>

<style>
:root {
	--full-viewport-height: 100vh;
}
</style>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.home-page {
	.main-content {
		.main-button-array {
			display: flex;
			justify-content: space-between;
			margin: 20px 20px 40px;

			.main-button {
				flex: 1;
				height: 56px;
				border: 1px solid #ebecee;
				display: flex;
				align-items: center;
				justify-content: center;
				@include subtitle_3();
				color: $text_primary;

				&:nth-child(odd) {
					margin-right: 20px;
				}

				img {
					width: 36px;
					height: 36px;
					margin-right: 10px;
				}
			}
		}

		.recommend-title {
			@include headline_3();
			margin-bottom: 10px;
		}

		.car-list-wrapper {
			padding-top: 10px;
			padding-left: 20px;
			padding-right: 20px;

			.load-more-area {
				background-color: #ffffff;

				&.hair {
					padding-bottom: 24px;
				}

				.loading-more-inner {
					height: 60px;
					display: flex;
					justify-content: center;
					align-items: center;
					@include subtitle_4(1.5, 400, false);

					.status-loading {
						color: $text_primary;
						display: inline-flex;
						align-items: center;
					}

					.status-fail {
						color: $text_disable;

						.retry-btn {
							color: $text-basic_active;
						}
					}

					.status-end {
						color: $text_disable;
						position: relative;
						&:before {
							content: ' ';
							top: 9px;
							width: 16px;
							height: 1px;
							position: absolute;
							background-color: $text_disable;
							left: -19px;
						}

						&:after {
							content: ' ';
							top: 9px;
							width: 16px;
							height: 1px;
							position: absolute;
							background-color: $text_disable;
							right: -19px;
						}
					}
				}
			}
		}

		.no-cars-warning {
			width: 100%;
			display: flex;
			flex-direction: column;
			// align-items: center;
			padding: 0 20px;

			.no-cars-tips {
				@include body_2(1.2, 400, false);
				color: $text_secondary;
			}
		}
	}

	::v-deep {
		.right-btn-list {
			display: flex;
			align-items: center;

			> * {
				height: 28px;
			}
			> :last-child {
				margin-left: 15px;
			}
		}

		.sort-menu {
			width: 100vw;
			background-color: rgba(0, 0, 0, 0.3);
			border-top: 1px solid #f0f1f2;
			z-index: 1000;

			.sort-way-list {
				background-color: #ffffff;

				padding: 0 25px 34px;

				.title-row {
					height: 57px;
					paddinig: 0 20px;
					display: flex;
					justify-content: space-between;
					align-items: center;

					> :first-child {
						@include subtitle_3(1.4, 500, false);
						font-weight: bold;
						color: $text_primary;
					}

					> :last-child {
						width: 40px;
						height: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						margin-right: -12px;
					}
				}

				.sort-way-item {
					@include font_text_m;

					height: 59px;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;

					.select-icon {
						visibility: hidden;
					}

					&.selected {
						color: $color_bs1_front;

						.select-icon {
							visibility: visible;
						}
					}
				}
			}
		}
	}
}
</style>
